/* eslint-disable */
import { faCircleExclamation, faCheck, faTimes, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons'
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { useState, useEffect, useRef } from 'react'

import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'

import MainTitle from '../../components/MainTitle'
import UserNav from '../../components/UserNav'
import Modal from '../../components/Modal'
import moment from 'moment'

const AccountSettings = () => {
  //Auth
  const { setShowLoader, can, createInfo, auth, setAuth } = useAuth()
  const { id } = useParams()

  const axios = useAxiosPrivate()
  const navigate = useNavigate()
  const location = useLocation()
  const errRef = useRef()

  const from = location.state?.from?.pathname || '/'

  const [userData, setUserData] = useState({})

  // Roles
  const [availableRoles, setAvailableRoles] = useState([])
  const [assignedRoles, setAssignedRoles] = useState([])
  const [assignRole, setAssignRole] = useState(null)
  const [deleteRole, setDeleteRole] = useState({})
  const [roles, setRoles] = useState([])

  const profileRef = useRef()

  // Modal
  const [showModal, setShowModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [modalView, setModalView] = useState(null)

  const [errMsg, setErrMsg] = useState('')

  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/

  const [validPwd, setValidPwd] = useState(false)
  const [pwdFocus, setPwdFocus] = useState(false)
  const [pwd, setPwd] = useState('')

  const [validMatch, setValidMatch] = useState(false)
  const [matchFocus, setMatchFocus] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [isValid, setIsValid] = useState(true)
  const [matchPwd, setMatchPwd] = useState('')

  const [vatRegistered, setVatRegistered] = useState('');

  const [businessType, setBusinessType] = useState('');

  const [accountDetails, setAccountDetails] = useState({ registered_business_name: "", trading_name: "", company_registration_number: "", utr: "", business_type: "", vat_registered: "", vat_number: "" })
  const [hourlyRateDetails, setHourlyRateDetails] = useState({from:"", in_hours_rate: "", out_of_hours_rate: "" })
  const [bankDetails, setBankDetails] = useState({ account_number: "", bank_account_name: "", bank_name: "", sort_code: "" })
  const [hourlyRatesChanged, setHourlyRatesChanged] = useState(false)

  useEffect(() => {
    getUserById(id)
  }, [id])

  useEffect(() => {
    const result = PWD_REGEX.test(pwd)
    setValidPwd(result)
    const match = pwd === matchPwd
    setValidMatch(match)
  }, [pwd, matchPwd, PWD_REGEX])

  useEffect(() => {
    if (!assignedRoles || assignedRoles?.length === 0) return
    let firstRole = assignedRoles[0].name
    setAvailableRoles(filterAvailableRoles(roles, assignedRoles))
  }, [assignedRoles])

  const handleBankInputChange = (event) => {
    const { name, value } = event.target;

    setBankDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleHourlyRateChange = (event) => {
    let {name, value} = event.target;

    if (name === 'in_hours_rate' || name === 'out_of_hours_rate') {
      value = parseFloat(value).toFixed(2)
    }

    if (name === 'new_hours_start') {
      name = 'from'
    }

    setHourlyRateDetails(prev => ({
      ...prev,
      [name]: value
    }))

    if (!hourlyRatesChanged) {
      setHourlyRatesChanged(true)
    }
  }

  const handleAccountInputChange = (event) => {
    const { name, value } = event.target;

    setAccountDetails(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'business_type') {
      setBusinessType(value);
    }

    if (name === 'vat_registered') {
      setVatRegistered(value);
    }

  };

  const updateAccountInformation = async () => {
    setShowLoader(true);

    try {
      const res = await axios.post(`/users/${id}/update-account-information`, accountDetails);
      createInfo('info', 'Account information updated');
      setShowLoader(false);
    } catch (err) {
      console.error(err);
      createInfo('error', 'Update failed');
      setShowLoader(false);
    }
  };

  const updateHourlyRates = async () => {
    setShowLoader(true);

    try {
      const res = await axios.post(`/users/${id}/update-hourly-rates`, hourlyRateDetails);
      createInfo('info', 'Account information updated');
      setShowLoader(false);
    } catch (err) {
      console.error(err);
      createInfo('error', 'Update failed');
      setShowLoader(false);
    }
  };

  const updateBankDetails = async () => {
    setShowLoader(true);


    try {
      const res = await axios.post(`/users/${id}/update-bank-details`, bankDetails);
      createInfo('info', 'Bank details updated');
      setShowLoader(false);


    } catch (err) {
      console.error(err);
      createInfo('error', 'Update failed');
      setShowLoader(false);
    }
  };

  const getUserById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/users/${id}`)
      if (response.data.result) {
        setUserData(response.data.result)
        setAssignedRoles(response.data.result.roles)

        setBankDetails(response.data.result.meta.bank_details)
        setAccountDetails(response.data.result.meta.account_information)
        setHourlyRateDetails(response.data.result.meta.hourly_rates[response.data.result.meta.hourly_rates?.length-1])

      } else {
        navigate(from, { replace: true })
      }
      setShowLoader(false)
    } catch (error) {
      setShowLoader(false)
    }
  }

  function formatSortCode(event) {
    let input = event.target
    let value = input.value.replace(/\D/g, '');
    if (value.length >= 3) {
      value = value.slice(0, 2) + '-' + value.slice(2, 4) + '-' + value.slice(4, 6);
    } else if (value.length >= 2) {
      value = value.slice(0, 2) + '-' + value.slice(2);
    }
    input.value = value;
  }

  function formatAccountNumber(event) {
    let input = event.target
    let value = input.value.replace(/\D/g, '');
    input.value = value.slice(0, 8);
  }

  const filterAvailableRoles = (allRoles, currentAssignedRoles) => {
    const assignedRoleIds = new Set((currentAssignedRoles || []).map((role) => role.id))
    return (allRoles || []).filter((role) => !assignedRoleIds.has(role.id))
  }

  const getRoles = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/roles/all`)
      if (response.data.result) {
        const available = filterAvailableRoles(response.data.result, assignedRoles)
        setRoles(response.data.result)
        setAvailableRoles(available)
        if (available.length > 0) {
          setAssignRole(JSON.stringify(available[0]))
        }
      }
    } catch (error) { }
    setShowLoader(false)
  }

  const uploadFile = async (e) => {
    e.preventDefault()
    setShowLoader(true)

    const selectedFile = e.target.files[0]
    const fd = new FormData()
    fd.append('image', selectedFile, selectedFile.name)
    try {
      const response = await axios.post('/users/update/' + userData.id, fd)
      setAuth({
        email: auth.email,
        pwd: auth.pwd,
        user: response.data.result,
        token: auth.token,
      })
      createInfo('info', 'Profile has been updated')
      setUserData(response.data.result)
    } catch (error) {
      if (!error?.response) {
        setErrMsg('No Server Response')
      } else if (error.response?.status === 400) {
        setErrMsg('Email or Password Missing.')
      } else if (error.response?.status === 401) {
        setErrMsg('Incorrect Email or Password entered.')
      } else {
        setErrMsg('Error Occured. Could not log you in.')
      }
      errRef.current.focus()
    }
    setShowLoader(false)
  }

  const ModalBody = () => {
    if (modalView === 'delete') {
      return <DeleteRoleElement />
    }

    if (modalView === 'assign') {
      return <AssignRoleElement />
    }

    createInfo('error', 'Modal View Unavailable')
    resetModal()
    return null
  }

  const AssignRoleElement = () => {
    const assignRoleSubmit = async (e) => {
      e.preventDefault()
      if (!assignRole) {
        createInfo('error', 'Please select a role to assign')
        return
      }

      setShowLoader(true)
      const data = JSON.parse(assignRole)

      try {
        const response = await axios.post(`/users/assign-role?filter=all`, {
          userId: userData.id,
          roleId: data.id,
        })
        createInfo('success', `Assigned Role: ${data.name}`)
        setUserData(response.data.result)
        setAssignedRoles(response.data.result.roles)
        setAvailableRoles(filterAvailableRoles(roles, response.data.result.roles))
        resetModal(false)
      } catch (error) {
        console.error(error)
      } finally {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={assignRoleSubmit}>
        <div className="mb-3">
          <label
            htmlFor="name"
            className="block font-medium text-gray-600 text-sm"
          >
            Role Name
          </label>
          <select
            value={assignRole}
            className="px-2 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            required
            onChange={(e) => setAssignRole(e.target.value)}
          >
            <option disabled value={{}}>
              Select Role
            </option>
            {availableRoles?.map((type) => {
              return (
                <option key={type.id} value={JSON.stringify(type)}>
                  {type.name}
                </option>
              )
            })}
          </select>
        </div>
        <div className="flex mt-2 w-full">
          <button className="btn mt-4 mr-4 w-1/2">Assign Role</button>
          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
          >
            Cancel
          </button>
        </div>
      </form>
    )
  }

  const resetModal = () => {
    setAssignRole(null)
    setDeleteRole(null)
    setModalView(null)
    setShowModal(false)
  }

  const assignRoleClicked = () => {
    getRoles()
    setAssignRole(null)
    setModalTitle(`Assign Role`)
    setModalView('assign')
    setShowModal(true)
  }

  const deleteRoleClicked = (role) => {
    setModalTitle('Delete Role: ' + role.name)
    setDeleteRole({ ...role })
    setModalView('delete')
    setShowModal(true)
  }

  const handlePhoneNumberChange = (event) => {
    const { value } = event.target
    setPhoneNumber(value)
    const isValidNumber = validatePhoneNumber(value)
    setIsValid(isValidNumber)
  }

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberUtil = PhoneNumberUtil.getInstance()

    try {
      const parsedNumber = phoneNumberUtil.parse(phoneNumber, 'GB')
      const isValidNumber = phoneNumberUtil.isValidNumber(parsedNumber)
      return isValidNumber
    } catch (e) {
      console.error('Error parsing phone number:', e)
      return false
    }
  }

  const update = async (e) => {
    e.preventDefault()
    setShowLoader(true)
    const data = {
      name: userData.name,
      email: userData.email,
      phone_number: userData.phone_number,
    }
    try {
      const response = await axios.post('/users/update/' + userData.id, data)
      setAuth({
        email: auth.email,
        pwd: auth.pwd,
        user: response.data.result,
        token: auth.token,
      })
      setUserData(response.data.result)
      createInfo('info', 'Profile has been updated')
    } catch (error) {
      if (!error?.response) {
        setErrMsg('No Server Response')
      } else if (error.response?.status === 400) {
        setErrMsg('Email or Password Missing.')
      } else if (error.response?.status === 401) {
        setErrMsg('Incorrect Email or Password entered.')
      } else {
        setErrMsg('Error Occured. Could not log you in.')
      }
      errRef.current.focus()
    }
    setShowLoader(false)
  }

  const updatePassword = async (e) => {
    setShowLoader(true)
    const data = {
      password: pwd,
    }
    const response = await axios.post('/users/update/' + userData.id, data)
    setAuth({
      email: auth.email,
      pwd: auth.pwd,
      user: response.data.result,
      token: auth.token,
    })
    createInfo('info', 'Password has been updated')
    setShowLoader(false)
    window.location.reload()
  }

  const DeleteRoleElement = () => {
    const removeRole = async (role) => {
      setShowLoader(true)
      try {
        const response = await axios.post(`/users/remove-role?filter=all`, {
          userId: userData.id,
          roleId: deleteRole.id,
        })
        createInfo('error', `Unassigned Role: ${deleteRole.name}`)
        setUserData(response.data.result)
        setAssignedRoles(response.data.result.roles)
        setAvailableRoles(filterAvailableRoles(roles, response.data.result.roles))
        resetModal(false)
      } catch (error) { }
      setShowLoader(false)
    }
    return (
      <form onSubmit={removeRole} className="justify-center flex">
        <div className="mb-3">
          <p className="text-lg font-bold my-8 text-center">
            Are you sure you want to delete this role?
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn red mt-4 mr-4 w-1/2">Delete Role</button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  return (
    <section>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      <MainTitle title="Account Settings" />

      <UserNav active="account-settings" userId={userData.id} />

      <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
        <h2 className="font-bold text-lg mb-4">Account Details</h2>
        <div className="flex">
          <div className="w-1/3 mr-4">
            <div className="flex flex-col items-center">
              <label
                htmlFor="photo"
                className="block font-medium text-gray-600 text-sm mb-2"
              >
                Profile Picture
              </label>
              <div className="rounded-full overflow-hidden relative w-40 h-40">
                <span
                  className="profile-pic"
                  style={{ backgroundImage: `url(${userData.profile_pic})` }}
                ></span>
                <span className="w-full h-full absolute top-0 left-0 flex items-center justify-center bg-gray-200 font-bold opacity-20"></span>
              </div>
              <div className="mt-2 relative rounded-md max-w-xs text-sm">
                <input
                  type="file"
                  hidden
                  ref={profileRef}
                  name="photo"
                  id="photo"
                  onChange={uploadFile}
                  className="shadown-md"
                />
                <p
                  ref={errRef}
                  className={errMsg ? 'errmsg' : 'offscreen'}
                  aria-live="assertive"
                >
                  {errMsg}
                </p>
                <label
                  htmlFor="photo"
                  className="btn primary mt-2"
                  onClick={(e) => profileRef.current.focus()}
                >
                  Change Photo
                </label>
              </div>
            </div>
          </div>
          <form className="w-2/3 ml-4 relative" onSubmit={update}>
            <div>
              <div className="max-w-sm mb-3">
                <label
                  htmlFor="name"
                  className="block font-medium text-gray-600 text-sm"
                >
                  Name
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={userData.name}
                    type="text"
                    name="name"
                    required
                    id="name"
                    onChange={(e) => (userData.name = e.target.value)}
                    className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                </div>
              </div>
              <div className="max-w-sm mb-3">
                <label
                  htmlFor="name"
                  className="block font-medium text-gray-600 text-sm"
                >
                  Email Address
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={userData.email}
                    type="email"
                    required
                    name="email"
                    id="email"
                    onChange={(e) => (userData.email = e.target.value)}
                    className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                </div>
              </div>
              <div className="max-w-sm mb-3">
                <label
                  htmlFor="name"
                  className="block font-medium text-gray-600 text-sm"
                >
                  Phone Number{' '}
                  <span className="text-blue-500 text-xs">
                    (Please use +44 and no spaces)
                  </span>
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={userData.phone_number}
                    type="text"
                    required
                    name="number"
                    id="number"
                    onChange={(e) => {
                      userData.phone_number = e.target.value
                    }}
                    onBlur={(e) => handlePhoneNumberChange(e)}
                    className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                  {phoneNumber.length > 0 && (
                    <>
                      {isValid ? (
                        <span className="text-green-500 text-sm">
                          Valid phone number
                        </span>
                      ) : (
                        <span className="text-red-600 text-sm">
                          Invalid phone number
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
              <button
                className="btn primary right-0 bottom-0"
                disabled={isValid ? '' : 'disabled'}
              >
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </section>
      {can('view roles') && (
        <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
          <div className="flex items-center mb-4 w-full justify-between">
            <h2 className="font-bold text-lg">Roles</h2>
            {can(`assign roles`) && (
              <div
                className="cursor-pointer ml-4 text-blue-500 font-bold items-center flex btn"
                onClick={assignRoleClicked}
              >
                <span>Assign Role</span>
              </div>
            )}
          </div>

          <ul className="flex">
            {assignedRoles?.map((role) => {
              return (
                <li key={role.id} className="flex">
                  <span className="pill">{role.name}</span>
                  {can('remove roles') && role.name !== 'Super User' ? (
                    <span
                      title="Remove Role"
                      className="pill-button"
                      onClick={() => deleteRoleClicked(role)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </span>
                  ) : (
                    <span className="mr-4"></span>
                  )}
                </li>
              )
            })}
          </ul>
        </section>
      )}

      <section className="w-full bg-white rounded-xl shadow-md py-4 px-6 mb-8 mt-8">
        <h2 className="font-bold text-lg mb-6">Account Information</h2>
        <div className='flex-col'>
          <div className='flex space-x-10'>
            {/* Business Section */}
            <div className={`w-[50%] pr-10 ${can('see hourly rates') && 'border-r-2'}`}>
              <div className="max-w-sm relative mb-4">
                <label htmlFor="business_type" className="mb-2">Business Type</label>
                <select name="business_type" id="business type" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md mb-6" value={accountDetails?.business_type}
                  onChange={handleAccountInputChange}>
                  <option value="select">Select Type</option>
                  <option value="sole_trader">Sole Trader</option>
                  <option value="partnership"> Partnership</option>
                  <option value="limited_company">Limited Company</option>
                  <option value="llp">LLP</option>
                  <option value="charity">Charity</option>
                  <option value="cic">CIC</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="max-w-sm relative mb-4">
                <label htmlFor="registered_business_name" className="mb-2">Registered Business Name</label>
                <input type='text' name="registered_business_name" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.registered_business_name}
                  onChange={handleAccountInputChange}>
                </input>
              </div>

              <div className="max-w-sm relative mb-4">
                <label htmlFor="trading_name" className="mb-3">Trading Name</label>
                <input type='text' name="trading_name" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.trading_name}
                  onChange={handleAccountInputChange}>
                </input>
              </div>

              {(businessType === 'limited_company' || businessType === 'llp' || businessType === 'cic' || businessType === 'charity') && (
                <div className="max-w-sm relative mb-4">
                  <label htmlFor="company_registration_number" className="mb-3">Company Registration Number</label>
                  <input type='text' name="company_registration_number" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.company_registration_number}
                    onChange={handleAccountInputChange}>
                  </input>
                </div>
              )}

              {(businessType === 'sole_trader' || businessType === 'partnership') && (
                <div className="max-w-sm relative mb-4">
                  <label htmlFor="utr" className="mb-3">Unique Taxpayer Reference</label>
                  <input type='text' name="utr" id="utr" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.utr}
                    onChange={handleAccountInputChange}>
                  </input>
                </div>
              )}

              <div className="max-w-sm relative mb-4">
                <label htmlFor="vat_registered" className="mb-3">VAT Registered?</label>
                <select name="vat_registered" id="vat_registered" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.vat_registered}
                  onChange={handleAccountInputChange}>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>

              {(vatRegistered === 'yes' && (businessType === 'limited company' || businessType === 'llp' || businessType === 'cic' || businessType === 'charity')) && (
                <div className="max-w-sm relative mb-4">
                  <label htmlFor="vat_number" className="mb-3">VAT Number</label>
                  <input type='text' name="vat_number" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md" defaultValue={accountDetails?.vat_number}
                    onChange={handleAccountInputChange}>
                  </input>
                </div>
              )}
              <button
                onClick={updateAccountInformation}
                className={`btn primary mt-2`}
              >
                Update Account Details
              </button>
            </div>

            {/* Hourly Information */}
            {can('see hourly rates') && (
              <div className='max-w-[50%] w-fit flex-col'>
                <div className='flex space-x-5'>
                  <div className="w-[200px] relative mb-4">
                    <label htmlFor="in_hours_rate" className="mb-2">Hourly Rate</label>
                    <div className="currency-wrap">
                      <span className="currency-code">&pound;</span>
                      <input
                        defaultValue={hourlyRateDetails?.in_hours_rate}
                        type="number"
                        name="in_hours_rate"
                        id="in_hours_rate"
                        onChange={handleHourlyRateChange}
                        className="pr-4 py-2 block pl-5 w-full border border-gray-300 rounded-md shadow-md [&::-webkit-inner-spin-button]:appearance-none"
                      />
                    </div>
                  </div>
                  <div className="w-[200px] relative mb-4">
                    <label htmlFor="out_of_hours_rate" className="mb-2">Out of Hours Rate</label>
                    <div className="currency-wrap">
                      <span className="currency-code">&pound;</span>
                      <input
                        defaultValue={hourlyRateDetails?.out_of_hours_rate}
                        type="number"
                        name="out_of_hours_rate"
                        id="out_of_hours_rate"
                        onChange={handleHourlyRateChange}
                        className="pr-4 py-2 pl-5 block w-full border border-gray-300 rounded-md shadow-md [&::-webkit-inner-spin-button]:appearance-none"
                      />
                    </div>
                  </div>
                </div>
                {hourlyRatesChanged && (
                  <div className='flex-col space-y-2'>
                    <div className='flex align-middle space-x-5 max-w-[535px]'>
                      <label htmlFor="new_hours_start" className="mb-2 py-2 whitespace-nowrap">Valid From:</label>
                      <input
                        id="new_hours_start"
                        name="new_hours_start"
                        type="date"
                        defaultValue={moment().format('YYYY-MM-DD')}
                        onChange={handleHourlyRateChange}
                        className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
                      />
                    </div>
                    <div className='flex justify-end'>
                      <button
                        className='btn primary mt-5'
                        onClick={updateHourlyRates}
                      >
                        Update Hourly Rates
                      </button>
                    </div>
                  </div>

                )}
              </div>
            )}

          </div>
        </div>
      </section>
      <section className="w-full bg-white rounded-xl shadow-md py-4 px-6 mb-8 mt-8">
        <h2 className="font-bold text-lg mb-6">Bank Details</h2>

        <div className="max-w-sm relative mb-3">
          <label htmlFor="bank_account_name" className="mb-2">Bank Account Name</label>
          <input type="text" name="bank_account_name" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md mb-4" defaultValue={bankDetails?.bank_account_name}
            onChange={handleBankInputChange}></input>
        </div>

        <div className="max-w-sm relative mb-3">
          <label htmlFor="bank_name" className="mb-2">Bank Name</label>
          <input type="text" name="bank_name" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md mb-4" defaultValue={bankDetails?.bank_name}
            onChange={handleBankInputChange}></input>
        </div>

        <div className="max-w-sm relative mb-3">
          <label htmlFor="sort_code" className="mb-2">Sort Code</label>
          <input type="text" name="sort_code" id="sort_code" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md mb-4" placeholder="12-34-56" maxLength="8" onInput={formatSortCode} defaultValue={bankDetails?.sort_code}
            onChange={handleBankInputChange}></input>
        </div>

        <div className="max-w-sm relative mb-3">
          <label htmlFor="account_number" className="mb-2">Account Number</label>
          <input type="text" name="account_number" id="account_number" className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md mb-4" placeholder="12345678" maxLength="8" onInput={formatAccountNumber} defaultValue={bankDetails?.account_number}
            onChange={handleBankInputChange}></input>
        </div>

        <button
          onClick={updateBankDetails}
          className={`btn primary mt-2`}
        >
          Update Bank Details
        </button>
      </section>
      <section className="w-full bg-white rounded-xl shadow-md py-4 px-6 mb-8 mt-8">
        <h2 className="font-bold text-lg mb-4">Account Settings</h2>
        <div>
          <h3 className="font-bold">Change Password</h3>
          <p className="mb-2">Update your password below.</p>
          <div className="max-w-sm relative mb-3">
            <label htmlFor="pwd">Password</label>
            <input
              type="password"
              id="pwd"
              onChange={(e) => setPwd(e.target.value)}
              required
              aria-invalid={validPwd ? 'false' : 'true'}
              aria-describedby="pwdnote"
              placeholder="Password"
              onFocus={() => setPwdFocus(true)}
              onBlur={() => setPwdFocus(false)}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
            <span
              className={
                validPwd ? 'valid input-check mt-5' : 'hide input-check mt-5'
              }
            >
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span
              className={
                validPwd || !pwd
                  ? 'hide input-check mt-5'
                  : 'invalid input-check mt-5'
              }
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
            <p
              id="pwdnote"
              className={pwdFocus && !validPwd ? 'instructions' : 'offscreen'}
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              8 to 24 characters. <br />
              Must include uppercase and lowercase letters, a number and a
              special character. <br />
              Allowed special characters:
              <span aria-label="exclamation mark"> !</span>
              <span aria-label="at symbol"> @</span>
              <span aria-label="hashtag"> #</span>
              <span aria-label="dollar sign"> $</span>
              <span aria-label="percent"> %</span>
            </p>
          </div>

          <div className="max-w-sm relative">
            <label htmlFor="confirm_pwd">Confirm Password</label>
            <input
              type="password"
              id="confirm_pwd"
              onChange={(e) => setMatchPwd(e.target.value)}
              required
              aria-invalid={validMatch ? 'false' : 'true'}
              aria-describedby="confirmnote"
              placeholder="Confirm Password"
              onFocus={() => setMatchFocus(true)}
              onBlur={() => setMatchFocus(false)}
              className="px-4 py-2 block w-full border border-gray-300 rounded-md shadow-md"
            />
            <span
              className={
                validMatch && matchPwd
                  ? 'valid input-check mt-5'
                  : 'hide input-check mt-5'
              }
            >
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span
              className={
                validMatch || !matchPwd
                  ? 'hide input-check mt-5'
                  : 'invalid input-check mt-5'
              }
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
            <p
              id="confirmnote"
              className={
                matchFocus && matchPwd && !validMatch
                  ? 'instructions'
                  : 'offscreen'
              }
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              Must match the first password input.
            </p>
          </div>
          <button
            onClick={updatePassword}
            className={`btn primary mt-4 ${!validPwd || !validMatch ? 'disabled' : 'enabled'
              }`}
          >
            Update Password
          </button>
        </div>
      </section>
    </section>

  )
}

export default AccountSettings
